import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css';
Vue.config.productionTip = false

// import plugin
import VueToastr from "vue-toastr";
// use plugin
Vue.use(VueToastr);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
